export const getInitials = (name: string): string => {
  if (!name || typeof name !== 'string') return '';
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
};
